module.exports = __webpack_public_path__ + "front/img/b48.a8890a64.jpg";